/**
 * Centralized status constants for pad-initialization feature.
 * This module serves as the single source of truth for all status values.
 * Follows the Flux Standard Action (FSA) pattern.
 */

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed'
};

// Optional: Export as default for cleaner imports
export default STATUS;
